import React, { memo } from 'react'
import { Path, Circle as _Circle } from 'react-native-svg'

import { IconProps } from '../IconProps'
import { IconBase } from '../IconBase'
import { themed } from '../themed'

const Icon = (props) => {
  const { color = 'black', size = 24, ...otherProps } = props
  return (
    <IconBase
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <Path
        d="M13.5 12C13.5 12.2967 13.412 12.5867 13.2472 12.8334C13.0824 13.08 12.8481 13.2723 12.574 13.3858C12.2999 13.4994 11.9983 13.5291 11.7074 13.4712C11.4164 13.4133 11.1491 13.2704 10.9393 13.0607C10.7296 12.8509 10.5867 12.5836 10.5288 12.2926C10.4709 12.0017 10.5006 11.7001 10.6142 11.426C10.7277 11.1519 10.92 10.9176 11.1666 10.7528C11.4133 10.588 11.7033 10.5 12 10.5C12.3978 10.5 12.7794 10.658 13.0607 10.9393C13.342 11.2206 13.5 11.6022 13.5 12ZM5.625 10.5C5.32833 10.5 5.03832 10.588 4.79165 10.7528C4.54497 10.9176 4.35271 11.1519 4.23918 11.426C4.12565 11.7001 4.09594 12.0017 4.15382 12.2926C4.2117 12.5836 4.35456 12.8509 4.56434 13.0607C4.77412 13.2704 5.04139 13.4133 5.33237 13.4712C5.62334 13.5291 5.92494 13.4994 6.19903 13.3858C6.47311 13.2723 6.70738 13.08 6.87221 12.8334C7.03703 12.5867 7.125 12.2967 7.125 12C7.125 11.6022 6.96697 11.2206 6.68566 10.9393C6.40436 10.658 6.02283 10.5 5.625 10.5ZM18.375 10.5C18.0783 10.5 17.7883 10.588 17.5416 10.7528C17.295 10.9176 17.1027 11.1519 16.9892 11.426C16.8757 11.7001 16.8459 12.0017 16.9038 12.2926C16.9617 12.5836 17.1046 12.8509 17.3143 13.0607C17.5241 13.2704 17.7914 13.4133 18.0824 13.4712C18.3733 13.5291 18.6749 13.4994 18.949 13.3858C19.2231 13.2723 19.4574 13.08 19.6222 12.8334C19.787 12.5867 19.875 12.2967 19.875 12C19.875 11.6022 19.717 11.2206 19.4357 10.9393C19.1544 10.658 18.7728 10.5 18.375 10.5Z"
        fill={`${color}`}
      />
    </IconBase>
  )
}

Icon.displayName = 'IconMore'

export const IconMore = memo(themed(Icon))
